/**
 * Редактор коллажей пользователя (Fabric.js + slick).
 *
 * Инициализируется только при наличии маркера #collage-canvas.
 * Конфиг (PHP-переменные) ожидается в window.collageEditorConfig — выставляется
 * минимальным inline-скриптом в шаблоне resources/views/user/collage-editor.blade.php.
 *
 * Зависимости (глобальные):
 *   - jQuery   — public/old_js/jquery.min.js (layouts/app.blade.php)
 *   - fabric   — CDN-скрипт в шаблоне
 *   - slick    — public/js/slick.min.js
 *
 * Ранее код жил inline в Blade (≈480 LOC), теперь — единый ES-модуль
 * в bundle через Laravel Mix.
 */

function buildCollageEditor(config) {
    const $ = window.jQuery || window.$;
    const fabric = window.fabric;
    if (!$ || !fabric) {
        console.error('[collage-editor] missing jQuery or fabric');
        return null;
    }

    const showToast = window.showToast || function () {};
    const TOAST_MESSAGES = window.TOAST_MESSAGES || { COLLAGE: { SELECT_OBJECT: '' } };

    return {
        collageId: config.collageId,
        projectId: config.projectId,
        roomId: config.roomId,
        canvas: null,
        isDirty: false,
        // Фиксированные размеры canvas (должны совпадать с PDFExportService.php)
        CANVAS_WIDTH: 1440,
        CANVAS_HEIGHT: 527,
        autoSaveTimer: null,

        init() {
            const self = this;

            this.canvas = new fabric.Canvas('collage-canvas', {
                width: this.CANVAS_WIDTH,
                height: this.CANVAS_HEIGHT,
                backgroundColor: '#f0f0f0',
                preserveObjectStacking: true,
            });

            this.canvas.on({
                'object:modified': () => { self.isDirty = true; self.scheduleAutoSave(); },
                'object:added':    () => { self.isDirty = true; self.scheduleAutoSave(); },
                'object:removed':  () => { self.isDirty = true; self.scheduleAutoSave(); },
                'path:created':    () => { self.isDirty = true; self.scheduleAutoSave(); },
            });

            // Загрузка сохранённого состояния
            if (config.canvasData) {
                this.loadCanvas(config.canvasData);
            } else if (config.background) {
                this.setBackgroundImage(config.background);
            }

            $('.adm_editor_selector_item').on('click', function () {
                const productId = $(this).data('product-id');
                if (!productId) return;
                let imageUrl = $(this).find('.adm_editor_selector_item_pic').css('background-image');
                imageUrl = imageUrl.replace(/^url\(['"]?/, '').replace(/['"]?\)$/, '');
                self.addProductToCanvas(productId, imageUrl);
            });

            $('.adm_editor_tools_item').on('click', function (e) {
                self.handleTool($(this).data('tool'), e);
            });

            $('#save-collage-btn').on('click', () => self.saveCollage());
            $('#download-collage-btn').on('click', () => self.downloadCollage());

            // Slick slider для продуктов (вертикальный) — только если их > 5
            if ($('#slider_editor .adm_editor_selector_item').length > 5) {
                $('#slider_editor').slick({
                    infinite: false,
                    speed: 500,
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    vertical: true,
                    verticalSwiping: true,
                    prevArrow: '',
                    nextArrow: '',
                });
            }

            // DEV-841: клики по стрелкам — рендерятся всегда; работают только когда slick инициализирован
            $('#slider_editor_next').on('click', () => {
                if ($('#slider_editor').hasClass('slick-initialized')) {
                    $('#slider_editor').slick('slickNext');
                }
            });
            $('#slider_editor_prev').on('click', () => {
                if ($('#slider_editor').hasClass('slick-initialized')) {
                    $('#slider_editor').slick('slickPrev');
                }
            });

            $('#background-upload').on('change', (e) => self.handleBackgroundUpload(e));
            $('#image-upload').on('change', (e) => self.handleImageUpload(e));

            $(window).on('resize', () => self.resizeCanvas());

            $(window).on('beforeunload.collage', () => {
                if (self.isDirty) return config.i18n.unsavedChanges;
            });

            // Подтверждение ухода по ссылке RETURN при наличии несохранённых изменений
            $(document).on('click.collage', 'a[href]', function (e) {
                if (!self.isDirty) return;
                const href = $(this).attr('href');
                if (!href || href.charAt(0) === '#' || $(this).attr('target') === '_blank') return;
                if (confirm(config.i18n.unsavedChanges)) {
                    // Уход подтверждён — снимаем beforeunload, чтобы не показывать второй (нативный) диалог
                    $(window).off('beforeunload.collage');
                } else {
                    e.preventDefault();
                }
            });
        },

        scheduleAutoSave() {
            const self = this;
            if (this.autoSaveTimer) clearTimeout(this.autoSaveTimer);
            this.autoSaveTimer = setTimeout(() => {
                if (self.isDirty) self.saveCollage(true);
            }, 3000);
        },

        resizeCanvas() {
            this.canvas.renderAll();
        },

        setBackgroundImage(url) {
            const self = this;
            fabric.Image.fromURL(url, (img) => {
                const canvasAspect = self.CANVAS_WIDTH / self.CANVAS_HEIGHT;
                const imgAspect = img.width / img.height;
                const scaleFactor = imgAspect >= canvasAspect
                    ? self.CANVAS_HEIGHT / img.height
                    : self.CANVAS_WIDTH / img.width;
                const newWidth = img.width * scaleFactor;
                const newHeight = img.height * scaleFactor;
                const left = (self.CANVAS_WIDTH - newWidth) / 2;
                const top = (self.CANVAS_HEIGHT - newHeight) / 2;

                self.canvas.setBackgroundImage(img, self.canvas.renderAll.bind(self.canvas), {
                    scaleX: scaleFactor,
                    scaleY: scaleFactor,
                    left,
                    top,
                });
            });
        },

        loadCanvas(canvasData) {
            const self = this;
            if (!canvasData || typeof canvasData !== 'string') return;

            try {
                const data = JSON.parse(canvasData);
                const bgImage = data.backgroundImage;

                this.canvas.loadFromJSON(data, () => {
                    if (bgImage && self.canvas.backgroundImage) {
                        const img = self.canvas.backgroundImage;
                        const canvasAspect = self.CANVAS_WIDTH / self.CANVAS_HEIGHT;
                        const imgAspect = img.width / img.height;
                        const scaleFactor = imgAspect >= canvasAspect
                            ? self.CANVAS_HEIGHT / img.height
                            : self.CANVAS_WIDTH / img.width;
                        const newWidth = img.width * scaleFactor;
                        const newHeight = img.height * scaleFactor;
                        img.scaleX = scaleFactor;
                        img.scaleY = scaleFactor;
                        img.left = (self.CANVAS_WIDTH - newWidth) / 2;
                        img.top = (self.CANVAS_HEIGHT - newHeight) / 2;
                    }
                    self.canvas.renderAll();
                });
            } catch (e) {
                console.error('Error loading canvas:', e);
            }
        },

        addProductToCanvas(productId, imageUrl) {
            const self = this;
            fabric.Image.fromURL(imageUrl, (img) => {
                const maxSize = 150;
                const scale = Math.min(maxSize / img.width, maxSize / img.height);
                img.set({
                    left: Math.random() * 400 + 100,
                    top: Math.random() * 300 + 100,
                    scaleX: scale,
                    scaleY: scale,
                    productId,
                });
                self.canvas.add(img);
                self.canvas.setActiveObject(img);
                self.canvas.renderAll();
            });
        },

        handleTool(tool, event) {
            const activeObject = this.canvas.getActiveObject();

            if (!activeObject && tool !== 'add-background' && tool !== 'upload-image' && tool !== 'pick-color') {
                showToast('warning', TOAST_MESSAGES.COLLAGE.SELECT_OBJECT);
                return;
            }

            switch (tool) {
                case 'mirror-h':       this.mirrorHorizontally(); break;
                case 'rotate':         this.rotate(event); break;
                case 'pick-color':     this.pickBackgroundColor(); break;
                case 'send-back':      this.sendBack(); break;
                case 'send-forward':   this.sendForward(); break;
                case 'add-background': $('#background-upload').click(); break;
                case 'upload-image':   $('#image-upload').click(); break;
                case 'delete':         this.deleteObject(); break;
            }
        },

        mirrorHorizontally() {
            const obj = this.canvas.getActiveObject();
            if (!obj) return;
            obj.set('flipX', !obj.flipX);
            this.canvas.renderAll();
        },

        rotate(event) {
            const obj = this.canvas.getActiveObject();
            if (!obj) return;
            const angle = obj.angle || 0;
            const rotationAngle = (event && event.shiftKey) ? -90 : 90;
            obj.rotate(angle + rotationAngle);
            this.canvas.renderAll();
        },

        pickBackgroundColor() {
            const self = this;
            const colorInput = $('<input type="color" style="display:none">');
            colorInput.on('change', function () {
                self.canvas.backgroundColor = this.value;
                self.canvas.renderAll();
                $(this).remove();
            });
            $('body').append(colorInput);
            colorInput.click();
        },

        sendBack() {
            const obj = this.canvas.getActiveObject();
            if (!obj) return;
            this.canvas.sendBackwards(obj);
            this.canvas.renderAll();
        },

        sendForward() {
            const obj = this.canvas.getActiveObject();
            if (!obj) return;
            this.canvas.bringForward(obj);
            this.canvas.renderAll();
        },

        deleteObject() {
            const obj = this.canvas.getActiveObject();
            if (!obj) return;
            this.canvas.remove(obj);
            this.canvas.renderAll();
        },

        // Растеризованное превью канваса. Может выбросить SecurityError, если на
        // канвас попали кросс-доменные изображения без CORS (canvas «загрязнён»).
        // В этом случае возвращаем null — сохраняем только данные коллажа, а превью
        // сервер пересоберёт из canvas JSON (PDFExportService::generateCompositeImage).
        exportPreview() {
            try {
                return this.canvas.toDataURL('image/png');
            } catch (e) {
                console.warn('[collage-editor] toDataURL failed (tainted canvas), saving without preview', e);
                return null;
            }
        },

        saveCollage(isAuto) {
            const self = this;
            const data = {
                _token: config.csrfToken,
                collage_id: this.collageId,
                canvas: JSON.stringify(this.canvas.toJSON(['productId', 'backgroundImage'])),
                background: this.canvas.backgroundImage ? this.canvas.backgroundImage.src : '',
            };
            const imageData = this.exportPreview();
            if (imageData) data.image = imageData;

            $.ajax({
                url: config.routes.save,
                method: 'POST',
                data,
                success(response) {
                    if (!response.success) return;
                    self.isDirty = false;
                    if (!isAuto) showToast('success', config.i18n.collageSaved);
                },
                error() {
                    if (!isAuto) showToast('error', config.i18n.errorSaving);
                },
            });
        },

        downloadCollage() {
            const self = this;
            if (!this.isDirty) {
                window.location.href = '/collage/' + this.collageId + '/download';
                return;
            }

            const data = {
                _token: config.csrfToken,
                collage_id: this.collageId,
                canvas: JSON.stringify(this.canvas.toJSON(['productId', 'backgroundImage'])),
                background: this.canvas.backgroundImage ? this.canvas.backgroundImage.src : '',
            };
            const imageData = this.exportPreview();
            if (imageData) data.image = imageData;
            showToast('info', config.i18n.generatingPdf);

            $.ajax({
                url: config.routes.save,
                method: 'POST',
                data,
                success(response) {
                    if (!response.success) return;
                    self.isDirty = false;
                    window.location.href = '/collage/' + self.collageId + '/download';
                },
                error() {
                    showToast('error', config.i18n.errorGeneratingPdf);
                },
            });
        },

        handleBackgroundUpload(e) {
            const self = this;
            const file = e.target.files[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = (ev) => self.setBackgroundImage(ev.target.result);
            reader.readAsDataURL(file);
        },

        handleImageUpload(e) {
            const self = this;
            const file = e.target.files[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = (ev) => self.addProductToCanvas('custom_' + Date.now(), ev.target.result);
            reader.readAsDataURL(file);
        },
    };
}

function init() {
    if (!document.getElementById('collage-canvas')) return;

    const config = window.collageEditorConfig;
    if (!config) {
        console.error('[collage-editor] window.collageEditorConfig not found');
        return;
    }

    const $ = window.jQuery || window.$;
    if (!$) {
        console.error('[collage-editor] jQuery not loaded');
        return;
    }

    $(() => {
        const editor = buildCollageEditor(config);
        if (!editor) return;
        editor.init();
        // Сохраняем для отладки/обратной совместимости
        window.collageEditor = editor;
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
